export const schedulingDocumentationMarkdown = `
# Scheduling Block

This block allows sending patients a link to schedule an appointment based on specified criteria.

## Configuration

1. **Practice IDs** (Required)
   - Select one or more practices where appointments can be scheduled.

2. **Provider User IDs** (Optional)
   - Choose specific providers within the selected practices.
   - If empty, all providers in the selected practices are available.

3. **Appointment Types** (Required)
   - Only fetch slots for specific appointment types.

## Important Notes

- At least one practice ID must be selected.
- Selected providers must belong to the specified practices.
- Use provider and appointment type filters to narrow down other scheduling options.
`;
